import PropTypes from "prop-types";
import { Box, Stack, Typography } from "@mui/material";

import {
  insightsKeyValueCardLabelSx,
  insightsKeyValueCardSurfaceSx,
  insightsKeyValueCardValueSx,
} from "./insightsComponentSx";

export default function KeyValueCard({ label, value, sx }) {
  return (
    <Box sx={insightsKeyValueCardSurfaceSx(sx)}>
      <Stack direction="column" spacing={1}>
        <Typography component="p" sx={insightsKeyValueCardLabelSx()}>
          {label}
        </Typography>
        <Typography component="p" sx={insightsKeyValueCardValueSx()}>
          {value}
        </Typography>
      </Stack>
    </Box>
  );
}

KeyValueCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  sx: PropTypes.object,
};
